import { render, staticRenderFns } from "./LeadTypeSelector.vue?vue&type=template&id=29598af1&scoped=true"
import script from "./LeadTypeSelector.vue?vue&type=script&lang=js"
export * from "./LeadTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29598af1",
  null
  
)

export default component.exports